import Vue from 'vue'
/**
 * 跳转去双机位监考小程序
 * @param {boolean} isDev
 * @returns
 */
export const goProctotingMini = ({ isDev, examType, recordInterval }) => {
  if (!window.location.search) {
    Vue.prototype.$message.info('参数错误')
    return
  }

  const query = window.location.search.split('?')[1]
  const queryObj = query.split('&').reduce((acc, cur) => {
    const [key, value] = cur.split('=')
    acc[key] = value
    return acc
  }, {})
  if (!queryObj.key) {
    Vue.prototype.$message.info('参数错误')
    return
  }
  const schemeUrl = generateProctoringMiniScheme({ key: queryObj.key, isDev, examType, recordInterval })
  window.location.href = schemeUrl
}

/**
 * 生成监考小程序scheme
 * @param {string} key
 * @param {boolean} isDev
 * @returns
 */
export const generateProctoringMiniScheme = ({ key, isDev, examType, recordInterval }) => {
  const isProd = window.CONFIG.env === 'production'
  let envVersion = isDev ? 'trial' : 'release'
  if (isProd) {
    envVersion = 'release'
  }
  let path = 'pages/index/index'
  if (examType === 'mental') {
    path = 'pages/mental/index'
  }
  return `weixin://dl/business/?appid=wxe4db96436318d03f&path=${path}&query=${encodeURIComponent(
    'key=' + key + '&recordInterval=' + recordInterval
  )}&env_version=${envVersion}`
}
